'use strict'

import Axios from 'axios'
import store from '@/store'
import config from '@/config'
import { Message, Modal } from 'view-design'
import { getLocalStorageItem } from '@/utils'

export const logMsg = (msg = '', type = 'success') => {
  Message[type] &&
    Message[type]({
      duration: 3,
      content:
        msg ||
        (type === 'success'
          ? '操作成功'
          : type === 'error'
            ? '服务器异常'
            : '操作失败')
    })
}
export const logModal = (msg = '', type = 'error') => {
  Message[type] &&
    Message[type]({
      duration: 3,
      content:
        msg ||
        (type === 'success'
          ? '操作成功'
          : type === 'error'
            ? '服务器异常'
            : '操作失败')
    })
  // Modal[type] &&
  //   Modal[type]({
  //     // title:"提示",
  //     content:
  //       msg ||
  //       (type === 'success'
  //         ? '操作成功'
  //         : type === 'error'
  //           ? '服务器异常'
  //           : '操作失败'),
  //     okText: '关闭'
  //   })
}

export const fetcher = Axios.create(config.service)
const uploadFetcher = Axios.create(config.service)

const codeMap = {
  FAILED: -1,
  SUCCESS: 200,
  CREATED: 201,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  SERVER_ERROR: 500,
  PARAMS_ERROR: 10001
}

function getToken () {
  let token = ''
  try {
    token = getLocalStorageItem(config.storage.authTokenKey)
  } catch (err) {
    console.error(err)
  }
  return token
}

function responseResolveInterceptor (response) {
  if (!response || !response.data) {
    return logMsg('服务器异常', 'error')
  }
  switch (response.status) {
    case codeMap.UNAUTHORIZED:
      logMsg(response.data.codeDescUser, 'error')
      store.dispatch('auth/clearAuthInfo').then(() => window.location.reload())
      break
    case codeMap.FAILED:
    case codeMap.FORBIDDEN:
    case codeMap.SERVER_ERROR:
    case codeMap.PARAMS_ERROR:
      logMsg(response.data.codeDescUser, 'error')
      break
    case codeMap.SUCCESS:
    case codeMap.CREATED:
      if (~~response.data.code) {
        logModal(response.data.codeDescUser, 'error')
      }
      break
    default:
      break
  }
  return {
    success: !~~response.data.code,
    ...response.data
  }
}

function responseRejectInterceptor (err) {
  const status = err.response ? err.response.status : err.code
  let message = '请求错误'
  if (err.message.indexOf('timeout') > 0) {
    message = '请求超时，请稍后再试'
  }
  console.error(err.message, status)
  logMsg(message, 'error')
  Promise.reject(err)
  return {
    success: false
  }
}

fetcher.interceptors.request.use(
  opt => {
    const token = getToken()
    if (token) {
      if (!opt.data) {
        opt.data = {}
      }
      opt.data.token = token
    }
    return paramsToJSON(opt)
  },
  err => Promise.reject(err)
)

fetcher.interceptors.response.use(
  responseResolveInterceptor,
  responseRejectInterceptor
)
uploadFetcher.interceptors.response.use(
  responseResolveInterceptor,
  responseRejectInterceptor
)

const wrap = (func = null, params = {}) => (config = {}) => {
  const data = {
    app: '1'
  }
  if (func) {
    data.func = func
  }
  const opt = {
    url: '/api',
    method: 'post',
    ...params,
    ...config,
    data: Object.assign({}, data, params.data, config.data)
  }
  if (opt.data.params) {
  } else {
    opt.data.params = {}
  }
  opt.data.realHospitalGuid = store.getters['auth/info'].allHospitalGuid || ''
  opt.data.params.admin_hospital =
    store.getters['auth/info'].allHospitalGuid || ''
  return fetcher.request(opt)
}

export default {
  login: wrap('login'),
  logout: wrap('logout'),
  getUserInfo: wrap('userInfo'),
  getModuleList: wrap('moduleList'),
  // 患者预约信息详情
  adminReserveInfo: wrap('adminReserveInfo'),
  // 互联网医院在线就诊挂号列表
  adminOnlineDiagnoseList: wrap('adminOnlineDiagnoseList'),
  // 改变订单状态
  adminDiagnoseSatus: wrap('adminDiagnoseSatus'),
  // 拒绝接诊
  refuseConsultation: wrap('refuseConsultation'),
  // 历史病例
  adminGetHistoryCase: wrap('adminGetHistoryCase'),
  // 病例填写内容
  adminOnlineCaseItem: wrap('adminOnlineCaseItem'),
  // 搜索获取药品
  newMedicineSearch: wrap('newMedicineSearch'),
  // 处方列表
  adminOnlineRecipeList: wrap('adminOnlineRecipeList'),
  diagnoseApplyDetail: wrap('diagnoseApplyDetail'),
  getTemplateList: wrap('getTemplateList'),
  // 修改处方
  editDiagnose: wrap('editDiagnose'),
  // 复开放列表
  adminGetRepeatCase: wrap('adminGetRepeatCase'),
  // 发送处方
  adminOnlineSendRecipe: wrap('adminOnlineSendRecipe'),
  // 作废处方
  adminOnlineRecipeDelete: wrap('adminOnlineRecipeDelete'),
  // 处方撤回
  adminOnlineRecipeRecall: wrap('adminOnlineRecipeRecall'),
  // 患者端】获取医院后台相关配置信息
  getHospitalConfigInfo: wrap('getHospitalConfigInfo'),
  // 检查报告列表
  adminCheckReportList: wrap('adminCheckReportList'),
  // 发送检查单
  adminSendCheckReport: wrap('adminSendCheckReport'),
  // 作废检查报告
  adminCheckReportRecall: wrap('adminCheckReportRecall'),
  // 搜索项目名称
  adminSearchCheckItem: wrap('adminSearchCheckItem'),
  // 搜索执行科室
  adminSearchCheckDep: wrap('adminSearchCheckDep'),
  // 检验报告列表
  adminExamineReportList: wrap('adminExamineReportList'),
  // 搜索检验项目名称
  adminSearchExamineItem: wrap('adminSearchExamineItem'),
  // 发送检验报告
  adminSendExamineReport: wrap('adminSendExamineReport'),
  // 保存病例
  adminOnlinePutCase: wrap('adminOnlinePutCase'),
  // ICD-10国际疾病分类搜索
  searchPrescriptionKinds: wrap('searchPrescriptionKinds'),
  // 作废检验报告
  adminExamineReportRecall: wrap('adminExamineReportRecall'),
  // 【医生端】主叫发起视频呼叫
  videoCallMo: wrap('videoCallMo'),
  // 获取未读消息
  getArchiveMsg: wrap('getArchiveMsg'),
  // 发送消息
  sendMsg: wrap('sendMsg'),
  // 获取医生的在线状态
  getOnlineStatus: wrap('getOnlineStatus'),
  // 修改医生的在线状态
  switchOnlineStatus: wrap('switchOnlineStatus'),
  // 视频问诊客户端状态反馈（关联订单和ChannelId）
  videoChannelIdReport: wrap('videoChannelIdReport'),
  // 药师管理-消息轮训提示
  getMessageInfoList: wrap('getMessageInfoList'),
  // 获取取药方式列表
  queryFetchDrugType: wrap('queryFetchDrugType'),
  // 确定选取取药方式
  selectFetchDrugType: wrap('selectFetchDrugType'),
  // 医护端获取诊疗记录列表
  queryDiagnosisRecordList: wrap('queryDiagnosisRecordList'),
  // 获取有方便的科室列表
  depListSourceNo: wrap('hospitalDepListSourceNo'),
  // 获取有方便号源的医生列表
  doctorListSourceNo: wrap('doctorListSourceNo'),
  // 搜索线下转诊 可预约列表
  searchSourceNo: wrap('searchSourceNo'),
  // 线下转诊
  offlineReferralAppointmentCreate: wrap('offlineReferralAppointmentCreate'),
  // 取消转诊
  offlineReferralCancel: wrap('offlineReferralCancel'),
  // 查看门诊报告
  getClinicPatientExams: wrap('getClinicPatientExams'),
  // 检查报告
  jianchaDetailQueryById: wrap('jianchaDetailQueryById'),
  // 检验报告
  jianyanDetailQueryById: wrap('jianyanDetailQueryById'),
  // 自助排班列表
  getSelfSchedulingList: wrap('getSelfSchedulingList'),
  // 编辑排班/新增自主排班
  addNewScheduling: wrap('addNewScheduling'),
  // 停诊
  closeScheduling: wrap('closeScheduling'),
  // 历史病历
  getOlCaseInfoHistory: wrap('getOlCaseInfoHistory'),
  // 科室列表
  getHospitalDepartmentShift: wrap('getHospitalDepartmentShift'),

  // 医生证书验证
  doctorCertValidation: wrap('doctorCertValidation'),
  // 获取CA激活二维码
  doctorCertActivationCode: wrap('doctorCertActivationCode'),
  // CA开启自动签
  doctorCertAutoSign: wrap('doctorCertAutoSign'),
  // CA是否为PC开启自动签
  getDoctorAutoSignResult: wrap('getDoctorAutoSignResult'),

  // 曹妃甸诊所开方
  getDoctorInitiateTreatmentList: wrap('getDoctorInitiateTreatmentList'),
  doctorInitiateTreatment: wrap('doctorInitiateTreatment'),
  getPatientByTestId: wrap('getPatientByTestId'),
  onlineDiagnoseList: wrap('onlineDiagnoseList'),

  // 云信音视频2.0 token
  getYxToken: wrap('getYxToken'),
  durationReport: (params = {}) => {
    const opt = {
      url: '/mvc',
      method: 'post',
      ...params
    }
    return fetcher.request(opt)
  },
  // 上传图片，被裁剪了
  uploadFile: (option = {}) => {
    const formData = new FormData()
    if (option.data) {
      Object.keys(option.data).map(key => {
        formData.append(key, option.data[key])
      })
    }
    formData.append('token', getToken())
    formData.append('app', '1')
    formData.append(
      option.name,
      option.file,
      option.filename || option.file.name
    )
    return uploadFetcher.post('/common/perform_upload_file', formData, {
      ...config.service,
      headers: {
        ...config.service.headers,
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 上传文件
  uploadFun: (option = {}, api, uploadParams) => {
    const formData = new FormData()
    if (option.data) {
      Object.keys(option.data).map(key => {
        formData.append(key, option.data[key])
      })
    }

    for (let key in uploadParams) {
      if (uploadParams[key]) {
        formData.append(key, uploadParams[key])
      }
    }
    formData.append('token', getToken())
    formData.append('app', '1')
    formData.append(
      option.name,
      option.file,
      option.filename || option.file.name
    )

    return uploadFetcher.post(api, formData, {
      ...config.service,
      headers: {
        ...config.service.headers,
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 上传图片，但是有大小显示，不超过5M,不会被压缩
  uploadFileChat: (option = {}) => {
    const formData = new FormData()
    if (option.data) {
      Object.keys(option.data).map(key => {
        formData.append(key, option.data[key])
      })
    }
    formData.append('token', getToken())
    formData.append('app', '1')
    formData.append(
      option.name,
      option.file,
      option.filename || option.file.name
    )
    return uploadFetcher.post('/common/perform_upload_original_pic', formData, {
      ...config.service,
      headers: {
        ...config.service.headers,
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

function paramsToJSON (config = {}) {
  if (config.data) {
    let params = config.data
    if (typeof params !== 'object') return String(params)
    let arr = []
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) return
      let val =
        typeof params[key] === 'string'
          ? params[key]
          : JSON.stringify(params[key])
      arr.push(`${key}=${encodeURIComponent(val)}`)
    })
    config.data = arr.join('&')
  }
  return config
}



// WEBPACK FOOTER //
// ./src/services/api.js